(function () {
  'use strict';

  function init() {
    var toc = document.querySelector('[data-blog-toc]');
    if (!toc) return;

    var links = Array.prototype.slice.call(
      toc.querySelectorAll('.blog-article-seo__toc-link')
    );

    toc.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link) return;
      var id = decodeURIComponent(link.hash.slice(1));
      var target = document.getElementById(id);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (history.replaceState) {
        history.replaceState(null, '', link.hash);
      }
    });

    var toggle = toc.querySelector('[data-blog-toc-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        toc.classList.toggle('is-open', !expanded);
      });

      toc.addEventListener('click', function (event) {
        if (toggle.offsetParent === null) return;
        if (event.target.closest('[data-blog-toc-toggle], nav')) return;
        toggle.click();
      });
    }

    if ('IntersectionObserver' in window && links.length) {
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var progress = toc.querySelector('.blog-article-seo__toc-progress');
      var linkById = {};
      var ids = [];
      links.forEach(function (link) {
        var id = decodeURIComponent(link.hash.slice(1));
        linkById[id] = link;
        ids.push(id);
      });

      var visible = {};
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            visible[entry.target.id] = entry.isIntersecting;
          });

          var activeId = null;
          var activeIndex = -1;
          for (var i = 0; i < ids.length; i += 1) {
            if (visible[ids[i]]) {
              activeId = ids[i];
              activeIndex = i;
              break;
            }
          }

          ids.forEach(function (id) {
            linkById[id].classList.toggle('is-active', id === activeId);
          });

          if (progress && activeIndex > -1) {
            var pct = ((activeIndex + 1) / ids.length) * 100;
            if (reduceMotion) progress.style.transition = 'none';
            progress.style.height = pct + '%';
          }
        },
        { rootMargin: '-80px 0px -70% 0px', threshold: 0 }
      );

      ids.forEach(function (id) {
        var el = document.getElementById(id);
        if (el) observer.observe(el);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
